import { Stack, Typography } from "@mui/material";
import { GREY } from "@/config/mui/colorPalette";

export const SuccessScreenSectionStack = ({
  label,
  options,
}: {
  label: string;
  options: {
    icon: React.ReactNode;
    content: React.ReactNode;
    isLast?: boolean;
  }[];
}) => (
  <Stack
    sx={{
      width: "100%",
    }}
  >
    <Typography variant="labelTiny" color="text.secondary" sx={{ mb: 1.5 }}>
      {label}
    </Typography>
    {options.map((option, index) => {
      const key = `${label}-${index}`;

      return (
        <Stack
          key={key}
          direction="row"
          gap={1}
          sx={{ mb: option.isLast ? 0 : 1.5 }}
        >
          <span style={{ color: GREY[50], lineHeight: 0 }}>{option.icon}</span>
          <span style={{ alignContent: "center" }}>{option.content}</span>
        </Stack>
      );
    })}
  </Stack>
);
